import { createApp } from 'vue';
import ArcoVue from '@arco-design/web-vue';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';
import globalComponents from '@/components';
import globalContants from '@/constants/globalContants';
import * as Sentry from '@sentry/vue';
import router from './router';
import store from './store';
import i18n from './locale';
import useVxeTable from './vxeTable';
import directive from './directive';
import { isDev } from './utils/common';
import App from './App.vue';
import '@/utils/base64';
// Styles are imported via arco-plugin. See config/plugin/arcoStyleImport.ts in the directory for details
// 样式通过 arco-plugin 插件导入。详见目录文件 config/plugin/arcoStyleImport.ts
// https://arco.design/docs/designlab/use-theme-package
// import '@/assets/style/global.less';
// import '@/assets/style/index';
// import '@/api/interceptor';

// amis css
import 'amis/sdk/sdk.css';
import 'amis/sdk/helper.css';
import 'amis/sdk/iconfont.css';

// 覆盖amis样式
import '@/assets/style/index';

// 字体集
import '@/assets/fontFamily/font.css';

const app = createApp(App);
app.config.globalProperties.$globalContants = globalContants;
app.provide('globalContants', globalContants);
app.use(ArcoVue, {});
app.use(ArcoVueIcon);

if (import.meta.env.VITE_SENTRY === 'true') {
  Sentry.init({
    release: import.meta.env.VITE_SENTRY_RELEASE,
    environment: isDev() ? 'development' : 'production',
    app,
    dsn: 'https://fa034e1750d880b3d83f11d805fa0173@sentry.app.qinsilk.com/17',
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      // new Sentry.Replay(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

useVxeTable(app);

app.use(router);
app.use(store);
app.use(i18n);
app.use(globalComponents);
app.use(directive);

app.mount('#app');
